import type { NucampUser } from "$lib/datamodel";
import { Crisp } from "crisp-sdk-web";

export function identifyUser(user: NucampUser | undefined) {
  try {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data:any = {
      website: "www.nucamp.co"
    };
    if (user) {
      data.UID = user.uid;
      if (user.email) Crisp.user.setEmail(user.email);
      if (user.displayName) Crisp.user.setNickname(user.displayName);
    }
    // console.log("identifyUser", data);
    Crisp.session.setData(data);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (err) {
    // console.log("Error while seeting Crisp data", user);
  }
}

export function show() {
  Crisp.chat.show();
}

export function hide() {
  Crisp.chat.hide();
}